<template>
  <v-dialog v-model="open" width="540px" :fullscreen="isMobileBreakpoint">
    <v-card flat>
      <v-toolbar elevation="0">
        <v-toolbar-title class="body-regular-medium font-weight-medium ml-3">
          {{ $t('message.pages.funnel.renameModal.title') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon
          @click="handleClose"
          class="close-icon ml-auto mr-3"
          size="24"
          color="grey"
          style="cursor: pointer"
        >
          mdi-close
        </v-icon>
      </v-toolbar>
      <v-card-text class="pt-4 px-7 input">
        <v-input
          v-model="funnelSelected.name"
          :label="$t('message.name')"
          :error-messages="dirty ? requiredField : []"
          :error="
            funnelSelected.name.length > 255 ||
            (dirty && funnelSelected.name.length === 0)
          "
          :max-length="255"
          outlined
          dense
          @input="dirty = true"
          @blur="dirty = true"
          autocomplete="off"
          counter="255"
        />
      </v-card-text>
      <v-card-actions
        class="px-7 py-7 card-actions"
        :class="{ 'mobile-actions': isMobileBreakpoint }"
      >
        <v-spacer></v-spacer>
        <base-btn
          type="tertiary"
          class="mr-3"
          text
          @click="handleClose"
          :disabled="isFetching"
        >
          {{ $t('message.cancel') }}
        </base-btn>
        <v-tooltip top :disabled="!renameTooltipMessage || isFetching">
          <template v-slot:activator="{ on, attrs }">
            <div
              class="btn-tooltip"
              v-bind="attrs"
              v-on="!canRename ? on : {}"
              style="display: inline-block"
            >
              <base-btn
                :disabled="!canRename || isFetching"
                :loading="isFetching"
                @click="handleConfirm"
              >
                <span>{{ $t('message.actions.confirm') }}</span>
              </base-btn>
            </div>
          </template>
          <span style="white-space: pre-line">
            {{ renameTooltipMessage }}
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import funnelApi from '@/services/funnelApi'
export default {
  name: 'DrmCreateGroup',
  components: {},
  data: () => ({
    open: false,
    edit: false,
    dirty: false,
    isFetching: false,
    funnelSelected: {
      name: '',
    },
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    canRename() {
      const count = this.funnelSelected?.name?.length
      return count > 0 && count <= 255 && !this.isFetching
    },
    requiredField() {
      return this.funnelSelected?.name?.length === 0
        ? [this.$t('message.requiredField')]
        : []
    },
    renameTooltipMessage() {
      const name = this.funnelSelected?.name?.trim() || ''

      if (name.length > 255) {
        return this.$t('message.maxLengthError', { maxLength: 255 })
      }

      if (name.length === 0) {
        return this.$t('message.requiredField')
      }

      return ''
    },
  },
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  mounted() {
    this.$root.$on('openRenameFunnel', (funnel) => {
      this.funnelSelected = funnel
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    async handleConfirm() {
      this.isFetching = true
      await funnelApi.renameFunnel(this.funnelSelected)
      this.$root.$emit('reloadFunnels')
      this.$root.$emit('rename-funnel', this.funnelSelected.name)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.pages.funnel.renameModal.toastSuccess'),
        type: 'success',
      })
      this.isFetching = false
      this.handleClose()
    },
    handleClose() {
      this.open = false
    },
    handleEnter() {
      this.handleCreate()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar {
  height: 70px !important;
}

::v-deep .v-toolbar__content {
  height: 70px !important;
}

.input::v-deep {
  label {
    left: -10px !important;
  }
}

.card-actions {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .base-button {
    width: 50%;
  }

  .btn-tooltip {
    width: 50%;

    .base-button {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.bgImg {
  background-size: contain;
}
</style>
